<style>
  .cpo-pod-list {
    display: flex;
    flex-direction: row;
    white-space: nowrap;
    flex-wrap: wrap;
    margin-bottom: -20px;
    gap: 25px;
  }
  .button-holder {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 20px;
    width:100%;
    gap: 20px;
  }
</style>

<h2 class="cpo-section-title">Change Permissions for {{ roleData?.friendlyName || roleData?.name || 'Unknown' }} ({{ roleData?.name }})</h2>

<div class="cpo-pod-list">
  <!--
  Only show checkboxes that can be configured by the current user.
  1) if merchant, show just configurable checkboxes
  2) otherwise, show all
  -->
  @for (category of accessCategories; track category) {
    <div style="display:flex;flex-direction:column;" class="cpo-pod-list">
      <div class="cpo-subheadeing">{{ (category || 'Unknown Category')| titlecase }}</div>
      <ul style="margin: 0px 0px 20px; padding: 0px; list-style: none;">
        @for (item of allAccessBitsToCheck; track item; let i = $index; let first = $first) {
          <li *ngIf="item.category == category">
            <input
              type="checkbox"
              style="cursor: pointer;"
              class="namespace"
              value="{{ item.name }}"
              [checked]="getChecked(item.name, item.category)"
              (click)="chkAccessBit_clicked($event, item.name)"
            />
            {{ item.friendlyName || item.name || 'Unknown' }}
          </li>
        }
      </ul>
    </div>
  }     

  <div class="button-holder">
    <input
      type="button"
      value="Cancel Permissions Changes"
      class="cancel"
      (click)="btnCancel_click()"
      />
    <input
      type="button"
      value="Save Permissions Changes"
      class="primary"
      (click)="btnSave_click()"
    />
  </div>
  
</div>